import { Reveal } from "@components/ui";

export default function DataProtectionSection() {
  return (
    <section className="w-full bg-[#122d63] py-12 md:py-16 lg:py-[100px] px-5 md:px-10 lg:px-[180px]">
      <div className="w-full max-w-[1368px] mx-auto font-albert-sans">
        <div className="flex flex-col lg:flex-row items-start lg:items-center gap-8 md:gap-10 lg:gap-16">
          {/* Left: text */}
          <Reveal direction="left" className="flex-1 min-w-0">
            {/* Badge */}
            <div className="inline-flex items-center gap-2 bg-white/10 rounded-full px-4 py-1.5 mb-5 md:mb-6">
              <svg viewBox="0 0 24 24" fill="none" className="w-4 h-4">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M9 12l2 2 4-4" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
              <span className="text-[12px] md:text-[13px] font-semibold text-white/90 tracking-wider uppercase">
                Data Protection
              </span>
            </div>

            <h2 className="text-[26px] md:text-[36px] lg:text-[44px] font-semibold text-white tracking-[-0.03em] leading-tight mb-4 md:mb-5">
              Data Protection & Privacy Notice
            </h2>

            <p className="text-[15px] md:text-[18px] text-white/70 leading-relaxed max-w-[600px]">
              All information shared with GAZ is protected under the{" "}
              <span className="text-white font-medium">
                UAE Federal Decree-Law No. 45 of 2021 on Personal Data Protection
              </span>
              . Your data is used only for service-related communication and will never be shared
              with third parties without consent.
            </p>

            {/* Trust indicators */}
            <div className="flex flex-wrap gap-3 mt-6 md:mt-8">
              {[
                { label: "Encrypted", icon: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" },
                { label: "GDPR Aligned", icon: "M9 12l2 2 4-4M22 12A10 10 0 112 12a10 10 0 0120 0z" },
                { label: "No Third-Party Sharing", icon: "M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2M9 11a4 4 0 100-8 4 4 0 000 8zM23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75" },
              ].map((badge) => (
                <div
                  key={badge.label}
                  className="flex items-center gap-2 bg-white/[0.07] rounded-full px-3.5 py-2"
                >
                  <svg viewBox="0 0 24 24" fill="none" className="w-4 h-4 text-white">
                    <path d={badge.icon} stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                  <span className="text-[12px] md:text-[13px] text-white/80 font-medium">
                    {badge.label}
                  </span>
                </div>
              ))}
            </div>
          </Reveal>

          {/* Right: CTA card */}
          <Reveal direction="right" className="w-full lg:w-auto shrink-0">
            <div className="bg-white/[0.08] border border-white/10 rounded-[20px] p-6 md:p-8 text-center lg:text-left lg:min-w-[280px]">
              {/* Shield icon */}
              <div className="w-16 h-16 rounded-full bg-white/10 flex items-center justify-center mx-auto lg:mx-0 mb-5">
                <svg viewBox="0 0 24 24" fill="none" className="w-8 h-8">
                  <rect x="3" y="11" width="18" height="11" rx="2" stroke="white" strokeWidth="1.5" />
                  <path d="M7 11V7a5 5 0 0110 0v4" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
                  <circle cx="12" cy="16" r="1.5" fill="white" />
                </svg>
              </div>

              <p className="text-[15px] md:text-[16px] text-white/70 mb-5 leading-relaxed">
                Read our full privacy policy to understand how we protect your personal data.
              </p>

              <a
                href="/privacy-policy"
                className="inline-flex items-center gap-2 bg-white text-[#122d63] rounded-full py-3 pl-6 pr-3 font-semibold text-[15px] md:text-[16px] hover:bg-white/90 transition-colors duration-300 group"
              >
                View Privacy Policy
                <span className="w-9 h-9 rounded-full bg-[#f03813] flex items-center justify-center group-hover:bg-[#d42f0f] transition-colors duration-300">
                  <svg viewBox="0 0 24 24" fill="none" className="w-4 h-4">
                    <path d="M5 12h14M12 5l7 7-7 7" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </span>
              </a>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
